import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { budgetRouteRef, costRecommendationRouteRef } from './routes';

export const awsFinopsFrontendPlugin = createPlugin({
  id: 'aws-finops-frontend',
  routes: {
    budget: budgetRouteRef,
    costRecommendation: costRecommendationRouteRef,
  },
});

// --- Budget extensions (formerly aws-budget-frontend) ---

export const AwsBudgetFrontendPage = awsFinopsFrontendPlugin.provide(
  createRoutableExtension({
    name: 'AwsBudgetFrontendPage',
    component: () => import('./budget/pages/Home').then(m => m.Home),
    mountPoint: budgetRouteRef,
  }),
);

export const EntityAWSBudgetHealthCard = awsFinopsFrontendPlugin.provide(
  createComponentExtension({
    name: 'BudgetHealthCardExtension',
    component: {
      lazy: () =>
        import('./budget/components/BudgetHealth').then(m => m.BudgetHealth),
    },
  }),
);

export const AwsBudgetHealthGrid = awsFinopsFrontendPlugin.provide(
  createComponentExtension({
    name: 'BudgetHealthCardGrid',
    component: {
      lazy: () =>
        import('./budget/components/BudgetHealthFetch').then(
          m => m.BudgetHealthFetch,
        ),
    },
  }),
);

// --- Cost Recommendation extensions (formerly aws-cost-recommendation-frontend) ---

export const AwsCostRecommendationPluginPage = awsFinopsFrontendPlugin.provide(
  createRoutableExtension({
    name: 'AwsCostRecommendationPluginPage',
    component: () =>
      import('./cost-recommendation/components/CostRecommendationCard').then(
        m => m.CostRecommendationCard,
      ),
    mountPoint: costRecommendationRouteRef,
  }),
);

export const EntityAwsCostRecommendationPluginCard =
  awsFinopsFrontendPlugin.provide(
    createComponentExtension({
      name: 'EntityAwsCostRecommendationPluginCard',
      component: {
        lazy: () =>
          import(
            './cost-recommendation/components/CostRecommendationCard'
          ).then(m => m.CostRecommendationCard),
      },
    }),
  );
